import { defaultAllSelection } from "services/constants/selections";
import React, { useMemo, useState } from "react";
import { EPFReport } from "./EPFReport";
import { payrollReports } from "services/constants";
import { ESIReport } from "./ESIReport";
import { useDispatch, useSelector } from "react-redux";
import { SalaryStatementReport } from "./SalaryStatementReport";
import { EmployeeBankDetails } from "./EmployeeBankDetails";
import { OTReportV2 } from "./OTReportV2";
import { setFilterApi } from "services/Redux/userManagament";
import { checkViewerPermission } from "services/utils/HelperFunction";
import { ReportNamesList, isAllCompanies } from "../ReportNamesList";
export const PayrollReports = () => {
  const [reportName, setReportName] = useState("Summarized working hours");
  const [showReports, setShowReport] = useState(false);
  const dispatch = useDispatch();
  const { companyId, companyName, userScreenAccess } = useSelector(
    (state) => state.tokenReducer,
  );

  // A report being present in this static list doesn't mean this role has
  // viewer access to it -- the module row hides correctly (findAccess gates
  // "Reports" itself), but every row inside it was rendering unconditionally
  // regardless of its own per-submodule `permissions.viewer` in the live
  // provisioning payload. Same "presence isn't access" gap already fixed for
  // Team Workspace's Reports list (see checkViewerPermission usage in
  // TeamZone/Reports/index.js).
  const accessiblePayrollReports = useMemo(
    () =>
      payrollReports.filter((report) =>
        checkViewerPermission(
          userScreenAccess?.module_details,
          "Reports",
          report.reportName,
        ),
      ),
    [userScreenAccess],
  );

  const renderComponent = () => {
    switch (reportName) {
      case "Salary Statement Report":
      case "Salary Statement":
        return (
          <SalaryStatementReport
            setShowReport={setShowReport}
            reportName={reportName}
          />
        );
      case "ESI Report":
      case "Employees' State Insurance (ESI)":
        return (
          <ESIReport setShowReport={setShowReport} reportName={reportName} />
        );
      case "EPF Report":
        case "Employees' Provident Fund (EPF)":
        return (
          <EPFReport setShowReport={setShowReport} reportName={reportName} />
        );
      case "Employees' Bank Details":
        return <EmployeeBankDetails setShowReport={setShowReport} />;
      case "Overtime (OT)":
        return (
          <OTReportV2 setShowReport={setShowReport} reportName={reportName} />
        );
      default:
        break;
    }
  };

  return !showReports ? (
    <ReportNamesList
      reports={accessiblePayrollReports}
      onOpen={(report) => {
        if (isAllCompanies(companyId, companyName, defaultAllSelection)) {
          window.alert("Please select specific company");
          return;
        }
        setShowReport(true);
        setReportName(report.label);
        dispatch(setFilterApi(true));
      }}
    />
  ) : (
    renderComponent() || null
  );
};
